import {
    Component,
    ElementRef,
    Optional,
    ViewChild,
    inject,
} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LayoutService } from './service/app.layout.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StaffSchoolRoleDto, User } from '../core/users/user.type';
import { SchoolSharedService } from '../core/school/school.service';
import { UserSharedService } from '../core/users/user.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { NotificationsComponent } from './notifications/notifications.component';
import { OverlayPanel } from 'primeng/overlaypanel';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { co } from '@fullcalendar/core/internal-common';
import { ClassroomSharedService } from '../core/classroom/classroom-shared.service';
import { Classroom } from '../core/classroom/classroom-shared.types';
import { StocksSharedService } from '../core/stock/stocks-shared.service';
import { ProductSharedervice } from '../core/product/product-shared.service';
import { Product, ProductCategory } from '../core/product/product-shared.types';
import { RequestSharedService } from '../core/request/request-shared.service';
import { StaffService } from '../modules/app/staff/staff.service';
import {
    StaffWithStockRequests,
    StaffWithStockRequestsPageResponse,
} from '../modules/app/staff/staff.types';
import { VendorService } from '../modules/app/inventory/vendor/vendor.service';
import { Vendor, VendorCategory } from '../core/inventory/vendor/vendor.types';
import { VendorSharedService } from '../core/inventory/vendor/vendor.service';

import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { NotificationDataService } from '../core/notifications/notification-data.service';
import { StocksServiceService } from '../modules/app/inventory/stock/stocks-service.service';
import { ProductService } from '../modules/app/inventory/product/product.service';
import { Stock } from '../core/stock/stocks-shared.types';
import { ClassroomService } from '../modules/app/classroom/classroom.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrls: ['./app.topbar.component.scss'],
})
export class AppTopBarComponent {
   
    menu: MenuItem[] = [];

    @ViewChild('searchInput', { static: false }) searchInput!: ElementRef;

    @ViewChild('menubutton') menuButton!: ElementRef;

    @ViewChild('moreOverlay') moreOverlay!: OverlayPanel;

    schools: StaffSchoolRoleDto[] = [];
    selectedSchool: StaffSchoolRoleDto | null = null;
    schoolDialogVisible = false;
    user: User | null = null;
    userRole: string | null = null;

    searchActive: boolean = true;
    searchActive2: boolean = false;
    userId!: any;
    notificationsCount: number = 0;

    selectedTab: string = 'Classroom';

    selectedMoreOption: string | null = null;

    searchQuery: string | null = '';

    searchResults: any[] = [];

    claroomSearchResults: Classroom[] = [];

    stockSearchResults: Product[] = [];

    productlistSearchResults: Product[] = [];

    stafflistsearch: StaffWithStockRequests[] = [];

    productcategories: ProductCategory[] = [];

    vendorlistsearch: Vendor[] = [];

    vendorcategoriessearch: VendorCategory[] = [];

    showMoreOptions: boolean = false;

    searchControl = new FormControl('');

    moreoptionselectedTab: string | null = '';

    isLoading = false;

    unreadCount = 0;

    moreOptions: string[] = [
        'Product Category',
        'Vendor List',
        'Vendor Category',
    ];

    constructor(
        public layoutService: LayoutService,
        private schoolService: SchoolSharedService,
        // private userNotificationService: NotificationService,
        public dialogService: DialogService,
        @Optional() public ref: DynamicDialogRef,
        private router: Router,
        private _route: ActivatedRoute,
        private _userService: UserSharedService,
        private _classroomSharedService: ClassroomSharedService,
        private _stocksSharedService: ProductService,
        private _productService: ProductSharedervice,
        private _staffService: StaffService,
        private _vendorService: VendorService,
        private _vendorSharedService: VendorSharedService,
        private notificationDataService: NotificationDataService,
        private _ClassroomService: ClassroomService,
         private _router: Router,
        
    ) {}

    
            
    ngOnInit() {
        const userCode =
            this._userService.userCode +
            '__' +
            this._userService.selectedSchoolCode;

        if (userCode) {
            this.notificationDataService.getUnreadCount(userCode).subscribe(
                (count) => {
                    this.unreadCount = count;
                },
                (err) => {
                    console.error('Error fetching unread count:', err);
                }
            );
        }

        this.searchControl.valueChanges
            .pipe(debounceTime(400), distinctUntilChanged())
            .subscribe(() => {
                this.handleSearch();
            });

        const initialData = this._route.snapshot.data['initialData'];
        this.user = initialData?.[1]?.data;
        this.schools = this.user?.staffSchoolRoles || [];

        // Try to get selected school code from localStorage
        let selectedCode = localStorage.getItem('selectedSchoolCode');
        if (
            !selectedCode ||
            !this.schools.some((s) => s.schoolCode === selectedCode)
        ) {
            selectedCode =
                this.schools.length > 0
                    ? this.schools[0].schoolCode ?? null
                    : null;
        }
        this.selectedSchool =
            this.schools.find((s) => s.schoolCode === selectedCode) || null;

        this.schoolService.school$.subscribe((school) => {
            if (school) {
                const found = this.schools.find(
                    (s) => s.schoolCode === school.code
                );
                this.selectedSchool = {
                    schoolCode: school.code ?? '',
                    schoolName: school.name ?? '',
                };
            }
        });

        if (this.user) {
            this.userId = `${this.user.code}`; // Assuming user.code is unique

            //   this.userNotificationService.fetchAndUpdateCount(this.userId);

            //   this.userNotificationService.unreadCount$.subscribe((count: number) => {
            //     this.notificationsCount = count;
            //   });
        }
    }

    get userService() : UserSharedService {
        return this._userService;
    }

        /**
     * Gets the initials from first and last name
     */
    getInitials(firstName?: string, lastName?: string): string {
      let initials = '';
      
      if (firstName) {
        initials += firstName.charAt(0).toUpperCase();
      }
      
      if (lastName) {
        initials += lastName.charAt(0).toUpperCase();
      }
      
      return initials || '?';
    }


    openAddUser(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        this._router.navigate(['/users'], {
            queryParams: {
                action: 'newUser',
                t: Date.now(), // forces query param change every click
            },
        });
    }

    openAddClassroom(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        this._router.navigate(['/classrooms'], {
            queryParams: {
                action: 'add',
                t: Date.now(),
            },
        });
    }

    openAddVendor(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        this._router.navigate(['/vendors/vendor-list'], {
            queryParams: {
                action: 'add',
                t: Date.now(),
            },
        });
    }

    openAddProduct(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        this._router.navigate(['/products/product-list'], {
            queryParams: {
                action: 'add',
                t: Date.now(),
            },
        });
    }

    openAddPurchase(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        this._router.navigate(['/purchase'], {
            queryParams: {
                action: 'add',
                t: Date.now(),
            },
        });
    }
    openAddRequest(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        this._router.navigate(['/requests'], {
            queryParams: {
                action: 'add',
                t: Date.now(),
            },
        });
    }

    hasAnyAddPermission(): boolean {
        return (
            this.userService.hasSchoolPermission('STAFF_CREATE') ||
            this.userService.hasSchoolPermission('CLASSROOM_CREATE') ||
            this.userService.hasSchoolPermission('VENDOR_CREATE') ||
            this.userService.hasSchoolPermission('PRODUCT_CREATE') ||
            this.userService.hasSchoolPermission('PURCHASE_CREATE') ||
            this.userService.hasSchoolPermission('REQUEST_CREATE')
        );
        }

    onSchoolChange(school: StaffSchoolRoleDto) {
        this.selectedSchool = school;
        if (this.selectedSchool?.schoolCode) {
            // Store selected school code in localStorage
            localStorage.setItem('selectedSchoolCode', this.selectedSchool.schoolCode);

            // Find the role and staffCode for the selected school from the current user object
            const matchedRole = this.user?.staffSchoolRoles?.find(
                (role) => role.schoolCode === this.selectedSchool?.schoolCode
            );
            if (matchedRole) {
                localStorage.setItem('userRole', matchedRole.role || '');
                localStorage.setItem('staffCode', matchedRole.staffCode || '');
                localStorage.setItem('userCode', this.user?.code || '');
                console.log("user code ",this.user );

                console.log("user code ",this.user?.code );
                console.log("user code ",this.user?.code );
                this._userService.userRole = matchedRole.role || '';
                this._userService.staffCode = matchedRole.staffCode || '';
            }

            // Optionally update school timezone if needed
            if (matchedRole?.schoolTimezone) {
                localStorage.setItem('selectedSchoolTimezone', matchedRole.schoolTimezone);
                this._userService.selectedSchoolTimezone = matchedRole.schoolTimezone;
            }

            // Fetch school data if needed
            this.schoolService
                .getSchoolByCode(this.selectedSchool.schoolCode)
                .subscribe((response) => {
                    if (response.success && response.data) {
                        console.log('School data:', response.data);
                    } else {
                        console.error('Failed to fetch school data');
                    }
                });

            // Redirect based on role
            if (matchedRole?.role === 'ADMIN') {
                this.router.navigate(['/dashboard']);
            } else if (matchedRole?.role === 'STAFF') {
                this.router.navigate(['/dashboard/overview']);
            } else {
                this.router.navigate(['/dashboard']);
            }

            // Reload the page to ensure all context is refreshed
            setTimeout(() => {
                window.location.reload();
            }, 100);
        }
    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    removeTab(event: MouseEvent, item: MenuItem, index: number) {
        this.layoutService.onTabClose(item, index);
        event.preventDefault();
    }

    get layoutTheme(): string {
        return this.layoutService.config().layoutTheme;
    }

    get colorScheme(): string {
        return this.layoutService.config().colorScheme;
    }

    get logo(): string {
        const path = 'assets/layout/images/WowInventory-logo-trans.png';
        const logo =
            this.layoutTheme === 'primaryColor' &&
            !(this.layoutService.config().theme == 'yellow')
                ? 'light.svg'
                : this.colorScheme === 'light'
                ? 'dark.svg'
                : 'light.svg';
        return path;
    }

    get tabs(): MenuItem[] {
        return this.layoutService.tabs;
    }

    Logout() {
        // Clear userCode and accessToken from localStorage
        localStorage.removeItem('userCode');
        localStorage.removeItem('userRole');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('selectedSchoolCode');
        localStorage.removeItem('permissions');
        localStorage.removeItem('staffCode');
        localStorage.removeItem('staffSchoolRoles');
        localStorage.removeItem('selectedSchoolTimezone');
        localStorage.removeItem('wow_access_token');
        localStorage.removeItem('wow_refresh_token');
        this.router.navigate(['/login']);
    }

    showBellNotificationDialog() {
        const tempData: any = { data: this.user };

        this.ref = this.dialogService.open(NotificationsComponent, {
            data: tempData,
            header: 'Notifications',
            width: '418px',
            contentStyle: {
                overflow: 'auto',
                height: '420px',
            },
            baseZIndex: 10000,
            position: 'topright',
            dismissableMask: true, // Add this property to close on outside click
            modal: true, // Ensures dialog has a backdrop
            closeOnEscape: true, // Allows closing with Escape key
        });

        this.ref.onClose.subscribe((res: any) => {
            // Handle notification read status updates if needed
            // Refresh unread count after dialog closes
            const userCode =
                this._userService.userCode +
                '__' +
                this._userService.selectedSchoolCode;
            if (userCode) {
                this.notificationDataService.getUnreadCount(userCode).subscribe(
                    (count) => {
                        this.unreadCount = count;
                    },
                    (err) => {
                        console.error('Error fetching unread count:', err);
                    }
                );
            }
        });
    }

        // Add to your topbar component
    getBadgeClass(count: number): string {
      if (count < 10) {
        return 'notification-badge single-digit';
      } else if (count < 100) {
        return 'notification-badge double-digit';
      } else if (count < 1000) {
        return 'notification-badge triple-digit';
      } else if (count < 10000) {
        return 'notification-badge quad-digit';
      } else {
        return 'notification-badge overflow';
      }
    }
    
    formatNotificationCount(count: number): string {
      if (count > 9999) {
        return '9999+';
      } else if (count > 999) {
        return count.toString();
      } else {
        return count.toString();
      }
    }

    // ++++++++++++++++++++++++

    activateSearch() {
        this.searchControl.setValue('');
        this.searchActive2 = true;
        this.selectedTab = 'Classroom';
        this.moreoptionselectedTab = '';
        this.selectedMoreOption = '';

        this.searchResults = [];
        this.stockSearchResults = [];
        this.claroomSearchResults = [];
        this.productlistSearchResults = [];
        this.stafflistsearch = [];
        this.productcategories = [];
        this.vendorlistsearch = [];
        this.vendorcategoriessearch = [];
    }

    onTopTabSelect(tab: string) {
        this.searchControl.setValue('');
        this.selectedTab = tab;
        this.moreoptionselectedTab = '';
        this.selectedMoreOption = '';
    }

    deactivateSearch() {
        console.log('hiding');
        this.searchActive = true;
        this.searchActive2 = false;
    }
    handleDialogClose() {
        console.log('Dialog closed');
        this.searchActive = true;
        this.searchActive2 = false;
        // Reset input
    }

    toggleMoreOptions() {
        this.showMoreOptions = !this.showMoreOptions;
    }

    selectMoreOption(option: string) {
        this.searchControl.setValue('');
        this.selectedMoreOption = option;
        this.selectedTab = option;
        this.moreoptionselectedTab = 'More';
        this.moreOverlay.hide();
    }

    handleSearch() {
        const query = this.searchControl.value?.trim();

        if (!query) {
            this.searchResults = [];
            this.stockSearchResults = [];
            this.claroomSearchResults = [];
            this.productlistSearchResults = [];
            this.stafflistsearch = [];
            this.productcategories = [];
            this.vendorlistsearch = [];
            this.vendorcategoriessearch = [];
            return;
        }

        switch (this.selectedTab) {
            case 'Classroom':
                this.searchClassrooms(query);
                break;
            case 'Stock':
                this.searchStocks(query);
                break;
            case 'Product List':
                this.searchProducts(query);
                break;
            case 'User':
                this.searchstaff(query);
                break;
            case 'Product Category':
              this.searchProductcategory(query);
              break;
            case 'Vendor List':
                this.searchVendorlist(query);
                break;
            case 'Vendor Category':
              this.searchVendorcategory(query);
              break;
            default:
                this.searchResults = [];
                this.stockSearchResults = [];
                this.claroomSearchResults = [];
                this.productlistSearchResults = [];
                this.stafflistsearch = [];
                this.productcategories = [];
                this.vendorlistsearch = [];
                this.vendorcategoriessearch = [];
        }
    }

    //   search apis

    searchClassrooms(query: string) {
        this.isLoading = true;
        this.claroomSearchResults = [];

        const schoolCode = this.selectedSchool?.schoolCode!;
        const isStaff = this.userService.userRole === 'STAFF' && this.userService.staffCode;

        if (isStaff) {
            this._classroomSharedService
                .getClassroomsPagedForStaff(schoolCode, this.userService.staffCode, query, 0, 20)
                .subscribe({
                    next: (res) => {
                        // Map response if needed
                        this.claroomSearchResults = (res?.data?.content || []).map((item: any) => ({
                            name: item.name,
                            schoolCode: item.schoolCode,
                            status : item.status,
                        }));
                    },
                    error: (err) => {
                        console.error('Search error:', err);
                        this.claroomSearchResults = [];
                    },
                    complete: () => {
                        this.isLoading = false;
                    },
                });
        } else {
            // Call admin API
            this._classroomSharedService
                .searchClassrooms(schoolCode, query)
                .subscribe({
                    next: (res) => {
                        this.claroomSearchResults = res?.data.content || [];
                    },
                    error: (err) => {
                        console.error('Search error:', err);
                        this.claroomSearchResults = [];
                    },
                    complete: () => {
                        this.isLoading = false;
                    },
                });
        }
    }

    searchStocks(query: string) {
        this.isLoading = true;
        this.stockSearchResults = [];

        console.log('Searching stock for:', query);

        this._stocksSharedService
            .getProductsPaged(this.selectedSchool?.schoolCode!, query, 0, 20)
            .subscribe({
                next: (res) => {
                    this.stockSearchResults = res.data?.content || [];
                    console.log(
                        'Stock search results:',
                        this.stockSearchResults
                    );
                },
                error: (err) => {
                    console.error('Stock search error:', err);
                    this.stockSearchResults = [];
                },
                complete: () => {
                    this.isLoading = false;
                },
            });
    }

    searchProducts(query: string) {
        this.isLoading = true;
        this.productlistSearchResults = [];

        console.log('Searching products for:', query);

        this._stocksSharedService
            .getProductsPaged(this.selectedSchool?.schoolCode!, query, 0, 20)
            .subscribe({
                next: (res) => {
                    this.productlistSearchResults = res?.data?.content || [];
                    console.log(
                        'Product list search results:',
                        this.productlistSearchResults
                    );
                },
                error: (err) => {
                    console.error('Product search error:', err);
                    this.productlistSearchResults = [];
                },
                complete: () => {
                    this.isLoading = false;
                },
            });
    }

    searchstaff(query: string) {
        this.isLoading = true;
        this.stafflistsearch = [];

        console.log('Searching staff for:', query);

        this._staffService
            .getStaffsPaged(this.selectedSchool?.schoolCode!, 0, 10, query)
            .subscribe({
                next: (res) => {
                    this.stafflistsearch = res?.data?.staffPage?.content || [];
                    console.log('Staff search results:', this.stafflistsearch);
                },
                error: (err) => {
                    console.error('Staff search error:', err);
                    this.stafflistsearch = [];
                },
                complete: () => {
                    this.isLoading = false;
                },
            });
    }

    searchProductcategory(query: string) {
        this.isLoading = true;
        this.productcategories = [];

        console.log('Searching product categories for:', query);

        this._productService
            .getPagedCategoriesBySchoolAndStatus(
                this.selectedSchool?.schoolCode!,
                'ACTIVE',
                0,
                10
            )
            .subscribe({
                next: (res) => {
                    this.productcategories = res?.data?.content || [];
                },
                error: (err) => {
                    console.error('Product category search error:', err);
                    this.productcategories = [];
                },
                complete: () => {
                    this.isLoading = false;
                },
            });
    }

    searchVendorlist(query: string) {
        this.isLoading = true;
        this.vendorlistsearch = [];

        this._vendorService
            .getVendorsPaged(
                this.selectedSchool?.schoolCode!,
                0,
                10,
                query,
                '',
                1,
                { status: '' }
            )
            .subscribe({
                next: (res) => {
                    this.vendorlistsearch = res?.data?.content || [];
                },
                error: () => {
                    this.vendorlistsearch = [];
                },
                complete: () => {
                    this.isLoading = false;
                },
            });
    }

    searchVendorcategory(query: string): void {
        this.isLoading = true;
        this.vendorcategoriessearch = [];

        this._vendorSharedService
            .getVendorCategoriesPagedBySchool(
                this.selectedSchool?.schoolCode!,
                0,
                10,
                query
            )
            .subscribe({
                next: (res) => {
                    this.vendorcategoriessearch = res?.data?.content || [];
                },
                error: () => {
                    this.vendorcategoriessearch = [];
                },
                complete: () => {
                    this.isLoading = false;
                },
            });
    }

    goToClassrooms(classroomName?: string) {
        this.searchActive2 = false;
          if (classroomName) {
            this.router.navigate(['/classrooms'], { queryParams: { nofiyId: classroomName } });
            } else {
                this.router.navigate(['/classrooms']);
            }
    }
    goToStocks(stockCode?: string) {
        this.searchActive2 = false;
        if (stockCode) {
        this.router.navigate(['/stocks'], { queryParams: { nofiyId: stockCode } });
        } else {
            this.router.navigate(['/stocks']);
        }
    }

    goToProductList(productCode?: string) {
        this.searchActive2 = false;
        if (productCode) {
            this.router.navigate(['/products/product-list'], { queryParams: { nofiyId: productCode } });
        } else {
            this.router.navigate(['/products/product-list']);
        }    
}

    goToUsers(staffCode?: string) {
        this.searchActive2 = false;
         if (staffCode) {
            this.router.navigate(['/users'], { queryParams: { nofiyId: staffCode } });
        } else {
            this.router.navigate(['/users']);
        }
    }

    goToProductCategory(categoryCode?: string) {
        this.searchActive2 = false;
         if (categoryCode) {
            this.router.navigate(['/products/product-category'], { queryParams: { nofiyId: categoryCode } });
        } else {
            this.router.navigate(['/products/product-category']);
        }
    }

    goToVendorList(vendorCode?: string) {
        this.searchActive2 = false;
          if (vendorCode) {
            this.router.navigate(['/vendors/vendor-list'], { queryParams: { nofiyId: vendorCode } });
        } else {
            this.router.navigate(['/vendors/vendor-list']);
        }
    }

    goToVendorCategory(categoryCode?: string) {
        this.searchActive2 = false;
        if (categoryCode) {
            this.router.navigate(['/vendors/vendor-category'], { queryParams: { nofiyId: categoryCode } });
        } else {
            this.router.navigate(['/vendors/vendor-category']);
        }
    }
}
